var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4286 10.4286C20.4286 12.3221 18.8935 13.8571 17 13.8571C15.1064 13.8571 13.5714 12.3221 13.5714 10.4286C13.5714 8.53502 15.1064 7 17 7C18.8935 7 20.4286 8.53502 20.4286 10.4286Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25.2856V21.353C9 20.1221 9.70456 18.9968 10.8574 18.5653C12.4124 17.9833 15.0343 17.2856 17 17.2856C19.0072 17.2856 21.2344 18.0131 22.9904 18.602C24.2189 19.014 25 20.1844 25 21.4802V25.2856",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.3e135842eedbbfa05d4aa3e558d4f689.svg";
export { ForwardRef as ReactComponent };